import Vue from "vue";
import App from "./News.vue";
import router from "./router";
import store from "@/common/store";
import Axios from "@/common/axios";
import Utils from "@/common/utils";
import VueGlobalConfig from "@/common/vueGlobalConfig";
import Setting from "@/config/setting";
import isLogin from "@/common/login";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/common.scss";
import "@/assets/css/view.scss";
import "@/assets/fonts/font-awesome/css/font-awesome.min.css";
import "@/assets/fonts/iconfont/iconfont.css";

// elementUI 引入
import ElementUI from "element-ui";

Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.use(Axios, { router });
Vue.use(Utils);
Vue.use(Setting);
Vue.use(VueGlobalConfig, {
  mixin: {
    getter: true,
    mutations: true,
    actions: true
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.needLogin === true) {
    // 需要登录
    // 判断是否登录
    isLogin()
      .then(() => {
        next();
      })
      .catch(() => {
        location.href = "/login";
      });
  } else {
    store.commit("UPDATE_LOGIN_STATUS", to.path != "/login");
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
